import React from 'react'
import { Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close';
import useStyles from './styles'
import { File } from './File';

const AttachmentsDialog = ({ files, open, onClose }) => {
    const classes = useStyles()
    const filesNoEmpty = files.some(objeto => Object.keys(objeto).length > 0);
    return (
        <Dialog open={open} onClose={onClose}>
            < DialogTitle className={classes.dialogTitle} > Adjuntos</DialogTitle >
            <IconButton className={classes.closeBtn} onClick={onClose}>
                <CloseIcon />
            </IconButton>
            <DialogContent className={classes.dialogContent}>
                {filesNoEmpty ? files.map(file => (
                    <File file={file} />
                )) :
                    <Typography>No hay archivos adjuntos</Typography>
                }
            </DialogContent>
        </Dialog >
    )
}

export { AttachmentsDialog }